import { render, staticRenderFns } from "./ToDashboard.vue?vue&type=template&id=24d94332&scoped=true&"
import script from "./ToDashboard.vue?vue&type=script&lang=js&"
export * from "./ToDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ToDashboard.vue?vue&type=style&index=0&id=24d94332&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d94332",
  null
  
)

export default component.exports